
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    current: {
      type: String,
      default: "home",
    },
    bg: {
      type: Boolean,
      default: true,
    },
    whiteLabel: {
      type: Boolean,
      default: false,
    },
    whiteLogo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabList: {
        home: { name: "服务介绍", link: "/" },
        news: { name: "公司动态", link: "/news" },
        about: { name: "关于我们", link: "/about" },
      },
    };
  },

  components: {},

  mounted() { },
});
